import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getQuality_ManualHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "qualitymanual", ...action.payload }),
		);
		yield put({
			type: types.GET_QUALITY_MANUAL_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_QUALITY_MANUAL_ERROR,
			payload,
		});
	}
}

export function* getQuality_ManualWatcherSaga() {
	yield takeLatest(types.GET_QUALITY_MANUAL_START, getQuality_ManualHandlerSaga);
}

//create

//delete

function* deleteQuality_ManualHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("qualitymanual", action.payload),
		);
		yield put({
			type: types.DELETE_QUALITY_MANUAL_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_QUALITY_MANUAL_ERROR,
			payload,
		});
	}
}

export function* deleteQuality_ManualWatcherSaga() {
	yield takeLatest(types.DELETE_QUALITY_MANUAL_START, deleteQuality_ManualHandlerSaga);
}

//update
